import React from "react";
import CrudResource from "./CrudResource";

const fields = [
  { key: "name", label: "Marka Adı" },
  { key: "logo_url", label: "Logo", type: "media", accept: "image", span: 2 },
  { key: "website", label: "Web Sitesi", span: 2 },
  { key: "order", label: "Sıra", type: "number" },
  { key: "active", label: "Aktif", type: "checkbox" },
];
const defaults = { name: "", logo_url: "", website: "", order: 100, active: true };

export default function AdminBrands() {
  return <CrudResource resource="brands" publicPath="brands" title="Markalar (Referanslar)" fields={fields} defaults={defaults} />;
}
